export const isVideo = (src = '') => {
	return /\.(mp4|mov)$/i.test(src || '');
};
